import type { ReactNode } from 'react';
import { Box, Stack, Typography } from '@mui/material';

export default function IllustratedEmptyState({
  imageSrc,
  imageAlt,
  imageDataQaElementId,
  message,
  messageDataQaElementId,
  children,
}: {
  imageSrc: string;
  imageAlt: string;
  imageDataQaElementId: string;
  message: ReactNode;
  messageDataQaElementId: string;
  children?: ReactNode;
}) {
  return (
    <Stack sx={{ alignItems: 'center', justifyContent: 'center', mx: '10%', gap: 2 }}>
      <Box
        component="img"
        src={imageSrc}
        alt={imageAlt}
        sx={{ width: '100%', maxHeight: 250 }}
        data-qa-element-id={imageDataQaElementId}
      />
      <Typography variant="body1" textAlign="center" data-qa-element-id={messageDataQaElementId}>
        {message}
      </Typography>
      {children}
    </Stack>
  );
}
